import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">This tool can help</div>
                                            <p>Taking time to think about the kind of person you are, your
                                                thinking style, and what drives you will
                                                help to ensure that you perform to your highest ability at work.
                                                This tool is all about <span className="brown brownbold"> how to get
the most out of yourself</span> and will help you to make the most of your potential, by guiding you to
                                                think about how to identify your strengths and weaknesses and
                                                match this up with your
                                                motivations at work.</p>

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>GETTING THE BEST OUT OF YOURSELF
                                            </div>
                                            <p>This may seem a broadly sweeping title for a development tool.
                                                The simple truth (supported by
                                                copious amounts of research) is that while there are techniques
                                                for becoming proficient at
                                                whatever you think you don’t do well, the way to really get the
                                                best out of yourself is to do those
                                                things for which you have an affinity or enjoy more often!</p>
                                            <div className="border_subtitle">At work, do you have the
                                                opportunity to do what you do best every day?
                                            </div>
                                            <p>Out of 198,000 people asked that question, those who said they
                                                did were 50% more likely to
                                                work where there was lower staff turnover, 38% more likely to
                                                work in more productive businesses,
                                                and 44% more likely to work for organisations whose customers
                                                offered praise more often
                                                than complaint.</p>
                                            <p>When we are given opportunities to do what we do well, or able to
                                                incorporate our strengths in
                                                our jobs, a positive cycle begins. That is, our resulting
                                                success builds confidence and motivation
                                                to do more of the same. There is evidence that this also
                                                positively impacts our performance
                                                generally, for example in our approach to problem solving and
                                                decision making.</p>

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>CAREER ANALYSIS CHART
                                            </div>
                                            <p>It’s surprising how many of us doggedly continue doing what
                                                neither inspires us nor makes use
                                                of our strengths, and then end up persuading ourselves that we
                                                have no choice – or even any
                                                talents. Here, we’ll show you how to identify your own talents
                                                and where you’ll find opportunity to
                                                use them in your job.</p>

                                            <p>Throughout your career there will have been ‘highs’ and ‘lows.’
                                                Try to remember what you were
                                                doing and which skills were required of you during those
                                                experiences. You’ll find this easier than
                                                it sounds if you fill in the Career Analysis Chart (we’ve also
                                                given you a completed
                                                one to show you how yours might look). Follow the step-by-step
                                                guide below:</p>
                                            <div className="border_subtitle">Step 1</div>
                                            <p>Create a timescale on the chart which covers the whole of your
                                                career, along the middle horizontal
                                                line (this depends on the length of your career). Then fill in
                                                the time interval along the axis.</p>
                                            <div className="border_subtitle">Step 2</div>
                                            <p>For each ‘time point’, think about where you were in your career
                                                and how you felt then: Was it a
                                                career high? Did you feel happy, successful and engaged in your
                                                job? Or, was it a career low; did
                                                you feel disengaged, unmotivated, bored or restless? Or were you
                                                neutral, coasting along with no
                                                strong feelings either way? For each time interval, plot where
                                                you remember being on this scale
                                                of job satisfaction. It might help to sum up with a notable
                                                event during that time, as shown in the
                                                example chart.</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>
                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}